import { CommandBase } from "../../../common/services/cqs/commandManager";
import { IPrimaryKey } from "../../../common/services/cqs/IPrimaryKey";

export class UpdateAtgardAvslutaArbetsorderRvCommand extends CommandBase {
    atagardId: number;
    grotvolym?: number;
    grotAnpassad?: boolean;
    atgardUtford?: boolean;
    kvalitetssakradGrotvolym?: number;
    arManuellGrotvolym: boolean;

    get primaryKey(): IPrimaryKey<UpdateAtgardAvslutaArbetsorderRvCommand> {
        return {
            atagardId: this.atagardId
        };
    }

    constructor(init: (instance: UpdateAtgardAvslutaArbetsorderRvCommand) => void) {
        super("UpdateAtgardAvslutaArbetsorderRvCommand");
        init(this);
    }
}
